import { createTheme, type MantineColorsTuple } from '@mantine/core';

const primary: MantineColorsTuple = [
  '#e8fbf5',
  '#d1f7eb',
  '#a3efda',
  '#75e7c9',
  '#47dfb8',
  '#14c38e',
  '#10a377',
  '#0c8360',
  '#086349',
  '#044332',
];

const success: MantineColorsTuple = [
  '#e5f9ed',
  '#ccf3db',
  '#99e7b8',
  '#66db94',
  '#33cf71',
  '#00a64d',
  '#008a40',
  '#006e33',
  '#005226',
  '#003619',
];

const warning: MantineColorsTuple = [
  '#fef3e6',
  '#fde7cd',
  '#facf9b',
  '#f8b769',
  '#f59f37',
  '#de6205',
  '#b85104',
  '#924003',
  '#6c2f02',
  '#461f01',
];

const danger: MantineColorsTuple = [
  '#fae8e9',
  '#f5d1d2',
  '#eba3a6',
  '#e17579',
  '#d7474d',
  '#bb393d',
  '#9c2f33',
  '#7d2528',
  '#5e1c1e',
  '#3f1214',
];

const info: MantineColorsTuple = [
  '#eef0f4',
  '#dde1e9',
  '#bbc3d3',
  '#99a5bd',
  '#7787a7',
  '#54617b',
  '#465167',
  '#384153',
  '#2a313f',
  '#1c212b',
];

const dark: MantineColorsTuple = [
  '#f4f4f5',
  '#e9e9eb',
  '#d3d3d7',
  '#bdbdc3',
  '#a7a7af',
  '#111319',
  '#0e1015',
  '#0b0d11',
  '#080a0d',
  '#050609',
];

export const theme = createTheme({
  primaryColor: 'primary',
  colors: {
    primary,
    success,
    warning,
    danger,
    info,
    dark,
  },
  
  fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  headings: {
    fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  
  defaultRadius: 'md',
  
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
    },
    Card: {
      defaultProps: {
        radius: 'md',
        shadow: 'sm',
      },
    },
    TextInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    PasswordInput: {
      defaultProps: {
        radius: 'md',
      },
    },
    Select: {
      defaultProps: {
        radius: 'md',
      },
    },
    Modal: {
      defaultProps: {
        radius: 'md',
      },
    },
    Paper: {
      defaultProps: {
        radius: 'md',
      },
    },
  },

  other: {
    transparent: 'transparent',
    almostBlack: '#111319',
    lightBlack: '#2F3336',
    almostWhite: '#E6E6E6',
    veryDarkBlue: '#08090C',
    slate: '#9BA6B2',
    slateLight: '#DAE1E9',
    slateDark: '#394351',
    smoke: '#F4F7FA',
    smokeLight: '#F9FBFC',
    smokeDark: '#E8EBED',
    accent: '#0366d6',
    yellow: '#F5BE31',
    warmGrey: '#EDF2F7',
    red: '#FF5C80',
    pink: '#FF4DFA',
    purple: '#9E5CF7',
    blue: '#3633FF',
    marine: '#2BC2FF',
    green: '#3ad984',
    bgSuccess: '#00A64D',
    bgSecondary: '#016b4be7',
    bgPrimary: '#14C38E',
    bgAccent: '#82B1FF',
    bgError: '#BB393D',
    bgWarning: '#DE6205',
    bgInfo: '#54617B',
    bgDefault: 'black',
  },
});
